import { takeEvery, put } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import queryString from 'query-string';

import {
  xcriticalFormError,
  xcriticalFormInit,
  xcriticalFormShowErrors,
} from '@xcritical/forms';

import { registryActions } from '@crm-framework/registry';

import {
  getWithdrawalFormData,
  TOOLS_REGISTERS,
  apiPostWireForm,
  formWireSaveRequestAction,
  FORM_NAME,
} from '@crm-package/tools';

import { validateFields } from './validation';
import { COMMON_REQUIRED_FIELDS } from './consts';

export function* watchApp() {
  yield takeEvery(formWireSaveRequestAction.type, handleSaveForm);
}

function* handleSaveForm() {
  try {
    const { model } = yield* select(getWithdrawalFormData);
    const { token } = queryString.parse(window.location.search);
    yield put(xcriticalFormShowErrors(FORM_NAME, true));

    const validationErrors = validateFields(model, COMMON_REQUIRED_FIELDS);

    if (validationErrors) {
      yield put(xcriticalFormError(FORM_NAME, validationErrors));
    } else {
      const withdrawalResponse = yield* call(apiPostWireForm, {
        token,
        model,
      });
      yield put(
        registryActions.set(TOOLS_REGISTERS.withdrawalResponse, {
          ...withdrawalResponse,
          status: 'OK',
        })
      );
      yield put(xcriticalFormInit(FORM_NAME, {}));
    }
  } catch (e) {
    const message = JSON.parse(e.message);
    console.error(message.error);
    yield put(
      registryActions.set(TOOLS_REGISTERS.withdrawalResponse, {
        status: 'error',
        message: message?.error,
      })
    );
  }
}
